import { jsxs as r, jsx as C } from "react/jsx-runtime";
function c(i) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "683",
      height: "683",
      viewBox: "0 0 683 683",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_104086_494)", children: [
          /* @__PURE__ */ C("path", { d: "M682.667 341.333C682.667 529.849 529.849 682.667 341.333 682.667C152.818 682.667 0 529.849 0 341.333C0 152.818 152.818 0 341.333 0C529.849 0 682.667 152.818 682.667 341.333Z" }),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M551.152 215.416C527.538 193.454 475.266 145.239 454.647 129.222C443.268 120.385 425.536 130.778 434.145 147.599L455.476 195.867C452.951 195.911 450.358 195.949 448.287 196.016C404.124 197.492 365.428 221.098 340.233 255.446C315.038 221.098 276.342 197.492 232.179 196.016C230.237 195.953 227.783 195.919 225.436 195.878L246.536 148.453C255.554 130.838 236.572 122.263 226.257 130.279C205.861 146.123 154.155 193.814 130.796 215.539C129.28 216.987 128.074 218.728 127.249 220.655C126.425 222.583 126 224.657 126 226.754C126 228.85 126.425 230.925 127.249 232.853C128.074 234.78 129.28 236.521 130.796 237.969C154.155 259.686 205.861 307.385 226.257 323.222C237.366 331.854 255.129 321.84 246.536 305.055L225.436 257.671C227.784 257.735 230.237 257.724 232.179 257.814C275.448 259.836 309.311 297.863 309.311 341.98V540.167C309.311 544.237 310.927 548.139 313.805 551.016C316.682 553.894 320.584 555.51 324.654 555.51H355.812C359.882 555.51 363.784 553.894 366.661 551.016C369.539 548.139 371.155 544.237 371.155 540.167V341.98C371.155 297.863 405.018 259.836 448.287 257.814C450.358 257.716 452.949 257.652 455.476 257.585L434.145 305.909C425.371 323.053 443.544 332.906 454.647 324.278C475.266 308.269 527.538 260.05 551.152 238.092C552.684 236.628 553.904 234.868 554.737 232.92C555.57 230.971 556 228.873 556 226.754C556 224.634 555.57 222.537 554.737 220.588C553.904 218.639 552.684 216.88 551.152 215.416Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_104086_494", children: /* @__PURE__ */ C("rect", { width: "682.667", height: "682.667", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
export {
  c as SplitTestRunIcon
};
